if(!customElements.get('counter-qty')){
  customElements.define('counter-qty', class Counter extends HTMLElement {
    constructor(){
      super();

      this.qty = this.querySelector('.product-form__input--quantity')
      this.plus = this.querySelector('[add-quantity]')
      this.decrease = this.querySelector('[decrease-quantity]')

      this.plus.addEventListener('click', this.onChangeQuantity.bind(this))
      this.decrease.addEventListener('click', this.onRemoveChangeQuantity.bind(this))
    }

    onChangeQuantity(evt){
      evt.preventDefault()
      this.qty.value = (Number(this.qty.value) + 1)
    }
  
    onRemoveChangeQuantity(evt){
      evt.preventDefault();
      this.qty.value =  this.qty.value > 0 ? this.qty.value - 1 : 0
    }

  })
}